import { get, writable } from "svelte/store";
import "../../services/companyinvoice.service";
import { ProjectService } from "../../services/project.service";
import { navigate } from "../../app.logic";
export const loading_projects = writable(false);
export const filter = writable({ criteria: {} });
export const pagination_projects = writable(null);
export const records = writable([]);
export const record = writable(null);
export async function initCompanyProjectsList(oid) {
    record.set(null);
    records.set([]);
    await loadProjects(oid);
}
export async function loadProjects(oid) {
    loading_projects.set(true);
    try {
        let _filter_project = get(filter);
        //_filter_project.criteria.query = `{ 'company':${oid}}`;
        _filter_project.criteria.company = oid;
        _filter_project.sorting = "+codiceProgetto";
        let _pag = get(pagination_projects);
        let _resp = await ProjectService.getProjectActions(_filter_project).toPromise();
        records.set(_resp.payload);
        //pagination_invoicesemails.set(_resp.pagination);
    }
    finally {
        loading_projects.set(false);
    }
}
export function onEdit(project) {
    console.log("onEdit", project);
    navigate(`/project/${project.detail.codiceCommessa}`);
}
